import Vue from 'vue';

// eslint-disable-next-line import/prefer-default-export
export const renderNativeElement = ({ vueComponent, props, events }) => {
    const host = document.createElement('div');
    const elem = new Vue({
        el: host,
        render(createElement) {
            return createElement(
                vueComponent,
                {
                    props,
                    on: events
                }
            );
        }
    });
    return elem.$el;
};
